// ═══════════════════════════════════════════════════════════
// Field Keys — 104 tables, all fields provisioned 2026-04-22
// System fields (record_id, created_at, updated_at, created_by, updated_by) omitted — accessed directly
// ═══════════════════════════════════════════════════════════

export const FIELDS = {
  incidents: {
    name: 'cqpsqobqb',
    incidentType: 'fb5d4cm4m',
    status: 'simaiblk2',
    location: 'u1437jl37',
    latitude: 'wab8mvjte',
    longitude: '4fucf2kj1',
    description: '3cygrpfn0',
    commander: 'ack3tfe24',
    startDate: 'd9nw73lfm',
    endDate: 'qctkp3vr7',
    severity: 'hdavs7a4g',
    createdByName: 'nv7ive8iz',
    createdByEmail: '9hysrwqfh',
  },
  activityLog: {
    incidentId: 'rzsb274ha',
    module: 'hlbyiwhq9',
    action: 'akztspedu',
    actorName: 'gzlh04tsl',
    actorEmail: 'oklf3140d',
    targetType: 'rirmhytvp',
    targetId: 'f1j3ichix',
    details: 't861gjw2c',
  },
  roles: {
    roleName: 'wmgnytdpj',
    roleSlug: '164oyjmkv',
    description: 'ucogf6wci',
    permissions: 'rbi68gkdd',
    isDefault: 't639p9uhk',
    sortOrder: 'o5mldn15v',
  },
  userRoles: {
    userEmail: 'je6cfv44e',
    userName: 'rk46mvki6',
    roleId: 'm45b4nnrm',
    roleName: 'rs620mdsm',
    assignedBy: 'jb0nmcvdb',
    assignedAt: '0ndirtffq',
  },
  appSettings: {
    settingKey: '59ufal0cm',
    settingValue: '1zqjerdx1',
    module: 'tqlp8xutl',
    description: 'dop7kq93h',
  },
  paOrganizations: {
    orgName: 'mw9a5gjvm',
    orgType: 'fm48ns5cc',
    orgRole: 'y88ul06qd',
    femaId: 'd8xousap5',
    uei: 'c8lghc9md',
    fipsCode: 'iusmj7gj6',
    primaryEmail: 'pdazgjju4',
    contactEmails: 'm2y9ry2lw',
    phone: 'pn40xz92a',
    address: 'b6tkbv8ao',
    city: '9yyriyc3o',
    state: 'qr6yfz5rf',
    zip: 'k0vo1m0pk',
    parentOrgId: 'fbuyp5bdo',
    status: 'eawre3rsi',
    notes: 'm87kfybje',
  },
  paDisasters: {
    disasterNumber: 'bzvtw021h',
    disasterName: 'jm4l29xzw',
    declarationType: 'lbl0xtkhd',
    declarationDate: 'n5dsgd4uf',
    incidentId: '6y0vndkla',
    incidentPeriodStart: 'ek485oi22',
    incidentPeriodEnd: '6bqm3llx2',
    federalSharePct: '26smlapeo',
    status: 'zw6ow5ux3',
    notes: '1kz88zlei',
  },
  paProjects: {
    projectNumber: 'rkbx693cq',
    title: 'f2y8y3q77',
    organizationId: 'zarmsuqoa',
    disasterId: '3smiyq0f2',
    workType: '97td6ahe1',
    damageCategory: '5k7jvs6p6',
    phase: 'wl4vqoma4',
    status: 'c9aech5td',
    estimatedCost: 'va2fg8zdl',
    obligatedAmount: 'vmltw3lup',
    drawdownAmount: 'bzxkp4x9z',
    federalSharePct: 'vsi4a9r0w',
    insuranceDeduction: 'h9yflta83',
    mitigationCost: 'y6trlx7ac',
    siteDescription: 'f49ab2kbi',
    scopeOfWork: 'euq4ou3qz',
    latitude: 'bw5ib4af5',
    longitude: '7mzoxkrms',
    address: 'o1owzs66e',
    city: 'wdu3nmdr0',
    state: 'vw9geo4xx',
    zip: '70ky19byd',
    completionDeadline: 'ecjryxni2',
    certificationDate: '5uqi9efeo',
    repairOrReplace: 'g5loiq4i7',
    notes: 'kokw2zz8s',
  },
  paProjectCosts: {
    projectId: 'ses7kcbgz',
    organizationId: '02q2qkauo',
    costType: '6nk788v4e',
    description: 'cu996cqss',
    quantity: 'g4o8bwsgx',
    unitCost: '5zs5g9grb',
    totalCost: '06bgbzqrv',
    unit: 'ulnzc13zu',
    category: 'kkum38ohx',
    notes: 'e39jtegq5',
  },
  paReimbursementRequests: {
    projectId: 'cmbod652h',
    organizationId: '3n46w8e6n',
    requestNumber: 'sc1kkt8v5',
    requestedAmount: 'dinihsoi2',
    approvedAmount: 'zppp6vp6i',
    federalShare: '03ehqtr64',
    applicantMatch: 'lidipm7hi',
    status: 'pdqatq3qf',
    costBreakdown: 't9uamcg5p',
    reviewerNotes: '6kds8ixjs',
    paymentRef: 'v76w8cvgj',
    submittedBy: '550eibmdb',
    submittedAt: 't0ujdbox3',
    reviewedBy: 's7qop6b0w',
    reviewedAt: 'c16qveqdd',
  },
  paTimeExtensions: {
    projectId: 'cwjh8g3io',
    organizationId: 'og4j2zv0g',
    disasterId: 'aqonik55j',
    requestDate: 'expe77ujd',
    currentDeadline: 'o4gljdj7b',
    requestedNewDeadline: '37xwf545w',
    extensionMonths: 'vzl8f1da1',
    recipientName: 'qleg979og',
    recipientTitle: 'pwur1zmcm',
    recipientOrg: '7y1isuoif',
    recipientAddress: 'kz1jq3x7c',
    recipientEmail: 'yk3ebnkqd',
    justification: 'a5irs749h',
    supportingCircumstances: 'c8207zusi',
    letterBody: 'm79m55zpd',
    letterContent: 'oqrub7czd',
    status: '33xl57odi',
    approvalDate: '76g7zm9zm',
    approvedBy: 'fssp3joza',
    approvedNewDeadline: 't5xu0bya6',
    createdBy: 'obpk1a0m9',
    submittedBy: 'avi9sid24',
    submittedAt: 'dcevk0bq0',
    reviewedBy: 'zqe6zrw5s',
    reviewedAt: '8pod08jeo',
    notes: '6yf5bo6wa',
  },
  paDocuments: {
    projectId: 'ub6pnha6o',
    organizationId: '701x8d4x3',
    title: '84afhhz9v',
    documentType: '5b04dp37m',
    file: 'gkrt6dmjm',
    tags: 'caonz4w1z',
    uploadedBy: '5ypn9v8j1',
    notes: 'xwo6vxqd3',
  },
  paDamageInventory: {
    disasterId: 'pdjmna84c',
    organizationId: 'avbp9fhio',
    projectId: '6paqz2y1f',
    siteName: 'f92cez00a',
    address: '4h2aqe7wp',
    city: 'kjzgxo280',
    state: 's832urubv',
    zip: '12fgw1by1',
    latitude: 'qep58gbl8',
    longitude: 'n3a7kd9e8',
    damageCategory: '2cs1xf022',
    severity: '0k0xfttac',
    description: '0y71wh4dr',
    estimatedCost: 'oarz1v954',
    status: 'gcqkqsamz',
  },
  paInsurance: {
    projectId: 'ep37busuz',
    carrier: 'rulrjd2nk',
    policyNumber: 'pyclm34gv',
    coverageType: 'cbjuvzggs',
    claimNumber: 'mxraoklyr',
    settlementAmount: 'y82fn3z7q',
    deductible: 'ndxcsjvr5',
    femaDeduction: 'nhwwbbqtv',
    status: '7q7eih5et',
    notes: '8mcf8nuez',
  },
  paNotes: {
    projectId: 'g9ake0en9',
    authorName: 'w3grdda74',
    authorEmail: 'kqbdt2chn',
    content: '06pyhd87h',
    noteType: 'bux58bxel',
  },
  paForceAccountEquipment: {
    projectId: 'mi0dqfril',
    organizationId: 'nm72mibjl',
    equipmentName: 'o135cr31m',
    equipmentType: 'esz9sueus',
    size: 'x83bahgm4',
    hoursUsed: 'rzhkmu6mc',
    ratePerHour: 'loco11l51',
    totalCost: '32icg7e7y',
    workDate: 'cycbrbqok',
    operator: 'g5cdnxjzn',
    notes: '9ynz8o9ko',
  },
  paMaterials: {
    projectId: '16uhjw3d1',
    organizationId: 'y4x2rm3oc',
    description: 'sq9pwwu48',
    vendor: 'oz8xmddyl',
    quantity: 'mx6lx9sd6',
    unitCost: '6k8cd8qda',
    totalCost: 'sac3aee6b',
    purchaseDate: 'z8k7i8rek',
    invoiceNumber: 'm6gjg2zt2',
    notes: 'toxq39eum',
  },
  paContracts: {
    projectId: 'ifx4shjhp',
    organizationId: 'p8e5fo6ht',
    contractorName: 'a77ncah1j',
    contractNumber: '9jia1cjfy',
    description: 'ilwmasnn5',
    contractAmount: '9xydki4dt',
    procurementMethod: 'p7jn2ak9c',
    startDate: 'x3dnlia3i',
    endDate: 'w0oacagdk',
    status: 'r4v3k8k1b',
    notes: '1es9iw0mc',
  },
  paRentedEquipment: {
    projectId: 'y02tveg7g',
    organizationId: 'y4vn7tsv9',
    equipmentName: '0tyq179p8',
    vendor: 'nptd2yiba',
    rentalRate: 'qsa4qe369',
    rentalPeriod: 'otov86pyf',
    totalCost: '4qr2s4i1w',
    startDate: 'ibhv64sc0',
    endDate: '9lmq6hkfk',
    notes: 'rhh2p7rv9',
  },
  paDonatedResources: {
    projectId: 'ag2fbm99j',
    organizationId: '7nz0j8iav',
    donorName: '4hozbgvsp',
    resourceType: 'zm2s3pecm',
    description: 'rcn4wykcc',
    estimatedValue: '5qjwyv22s',
    hoursContributed: '5psoxecr2',
    donationDate: 'zy3wg6gao',
    notes: '7xmho2edw',
  },
  paCompliance: {
    projectId: '8ql2820c6',
    nepaRequired: 'sowz07tna',
    nepaStatus: 'ceya7i5tl',
    section106Required: '6kanhsdye',
    section106Status: '5yzfzyd6m',
    floodplainReview: 'am6ul78ro',
    floodInsurance: 'pqnlgeai5',
    hazmatReview: 'n1gej7h7m',
    esaReview: '45n6dh431',
    wetlandsReview: 'ga96hrv26',
    notes: 'qqeatbpkg',
  },
  paTimelineEvents: {
    projectId: '3ekwyt9zy',
    eventType: 'vftkur5k1',
    title: 'a6pfstfjj',
    description: '1ljv6kr91',
    eventDate: 'jsa6ihnij',
    createdBy: 'c9dmdu1ad',
    status: 'zl7qeema3',
  },
  paChecklistTemplates: {
    itemKey: '9ns6nsj86',
    label: 'ikpvancpa',
    category: 'jpjx045n1',
    description: 'e9n8rnkbf',
    required: 'f484kl84s',
    sortOrder: 'wpdv2x5co',
    isActive: 'ttytc8794',
    programType: '3pwtfwiw6',
  },
  paMitigationProposals: {
    projectId: '9d8myxjlx',
    title: 'ibv7jd45z',
    description: '2bttfbagt',
    mitigationCost: 'a8xgr0psm',
    eligibleProjectCost: 'cjido4d6s',
    thresholdPct: 'nejib0pom',
    bcrRatio: 'lop0hmj4f',
    narrativeBody: '86ejfnaz7',
    status: 'aw1wm7zlk',
    submittedAt: 'qmghxkqx1',
    notes: 'b6ley1d92',
  },
  debrisZones: {
    incidentId: 'ollxw8wr0',
    zoneName: 'y5wmhp1ny',
    zoneCode: '6emw3jocj',
    geometry: 'p32gcb3uy',
    centroidLat: '4j8w37h73',
    centroidLng: 'zokc32k3c',
    estimatedCY: 'p2ivko2dk',
    actualCY: 'zm24o5ft0',
    currentPass: '4z5xmya4z',
    passHistory: 'uky8gd1wn',
    status: 'fcroacyqb',
    notes: 'xl0utiad8',
  },
  debrisContractors: {
    incidentId: 'fxemnkmly',
    companyName: 'nyo938djj',
    contractNumber: '0fe33070d',
    contactName: '3ta9z6wg6',
    contactPhone: '7a136gg34',
    contactEmail: 'bco8xj39g',
    contractAmount: 'bbucv0hkk',
    status: '4wipfec6n',
    notes: 'cqs49ze3z',
  },
  debrisTrucks: {
    contractorId: '4c0o5j4v9',
    truckNumber: 'n7etsymaa',
    licensePlate: 'aox138083',
    truckType: 'fr69anger',
    capacityCY: 'poswvmlg1',
    hasTailgate: 'rtwk6ujra',
    certStatus: '3ubghyjqu',
    certifiedDate: 'rjm9v3gze',
    certExpiresAt: 'gdd4ijbew',
    placardNumber: '5c9x80oer',
    driverName: 'tnz2gi3z3',
    driverPhone: 'gk2xsh8ko',
    notes: 'feyex43z9',
  },
  debrisLoadTickets: {
    incidentId: 'xr26po29k',
    ticketNumber: '80bg1e8qu',
    zoneId: '54qb381e9',
    contractorId: 't90hhc6ft',
    truckId: '170enzyms',
    disposalSiteId: 'gofypuob6',
    debrisType: 'ca96a8p22',
    measurementMode: 'zn95hch28',
    calculatedCubicYards: 'z1kltzbto',
    unitCount: '4loq9imo0',
    weight: 'hmtuh4uxj',
    loadingLoadPct: 'ya0mpbz7e',
    towerLoadPct: 'qph77jvlw',
    handLoaded: 'uz4w86e2v',
    pickupStopsJson: 'c98b4n6yw',
    status: 'wwnu8u1xg',
    loadingMonitorName: 'md91lvbtp',
    loadingMonitorSignature: 'ssexs03v0',
    driverPickupSignature: 'l4knmy9f4',
    towerMonitorName: 'eu0iuxjzc',
    towerMonitorSignature: 'qckcqvvrl',
    driverDeliverySignature: 'cqv9iqyod',
    verifiedAt: 'u8grn6nw9',
    notes: 'ytgvgj8lz',
  },
  debrisDisposalSites: {
    incidentId: 's4yz85asl',
    siteName: 'jxg45z33q',
    siteType: 'yt5ihwx2p',
    address: 'dwfqk0dtg',
    latitude: 's8o5nq87t',
    longitude: 'wi4g3r8tu',
    totalCapacity: 'bsjfalxxw',
    currentVolume: 'zkfqq53mi',
    acceptedTypes: 'xx31gcr6p',
    operatorName: '3o0uu27l1',
    operatorPhone: 'z10g8jt0h',
    status: 'rtroa6h43',
    notes: '1kfu3i6ui',
  },
  debrisMonitors: {
    fullName: '2t5s1be7w',
    company: 'yfkeitlby',
    email: '0c7y6eeld',
    phone: 'pnyt4hlor',
    role: 'u9h763uxe',
    assignedSites: 'mz2k9abx5',
    assignedZones: 'xp1l9iu9g',
    certifications: 'oa85e75ef',
    status: 'lzvj9mse9',
    notes: 'y3edfwppw',
  },
  debrisRateSchedules: {
    contractorId: 'vd2hcgnqw',
    lineItemCode: 'vp18ygc93',
    description: 't19grab85',
    unit: 'm4h9y7esv',
    rateTier1: '5i3dgayav',
    rateTier2: '3t5nu674q',
    rateTier3: 'sr5zvnmhq',
    rateTier4: '0tyb453jy',
    category: 'dwrq6xjnc',
    notes: '9w0plocqa',
  },
  debrisRightofEntry: {
    incidentId: 'dossuvd7a',
    propertyAddress: 'xrlka07uw',
    latitude: 'sh7lu9cus',
    longitude: 'cubbgbys2',
    ownerName: 'wkr4cdoom',
    ownerPhone: 'qg1s5mnkr',
    ownerEmail: '0tvzj77q2',
    ownerSignature: 'sg3by87ps',
    signedDate: 'm6pba5o36',
    zoneId: 'n6dznwcrk',
    debrisTypes: 'meaok0pv8',
    status: 't3xosp209',
    clearedDate: 'fj177eteb',
    clearedBy: '2xu3ghn4y',
    notes: 'u3fze4teu',
  },
  debrisInvoices: {
    incidentId: 'pae3fsz12',
    contractorId: 'd4rzan7q1',
    invoiceNumber: 'tca9n2b1j',
    invoiceDate: 'pzjb8rqi2',
    periodStart: 'nkqb5fvpv',
    periodEnd: 'yrqijt7b2',
    totalAmount: 'gltfv3o6p',
    approvedAmount: 'dptub19nc',
    status: 'lbm9w7gld',
    lineItems: '49go7pmk8',
    reviewerNotes: '8awpo6nst',
    paymentRef: '8t7vrkmmi',
  },
  cameraSources: {
    name: '1l1lq1a4x',
    provider: 'oi573t25f',
    baseUrl: 'bgg9olzso',
    apiKey: '4r9a9ehks',
    listEndpoint: 'hs6pczkwo',
    snapshotEndpoint: 'yjha8ltzd',
    streamEndpoint: '6ki3sfv1z',
    fieldMapping: '2f3tlu20t',
    refreshInterval: '9umo1wvoh',
    regionLat: 'bir6cjfxr',
    regionLng: 'do5b53uij',
    regionRadius: 'zilmksdhd',
    status: 'chu8thveb',
  },
  gisDataSources: {
    name: 'zlaqw4hb7',
    url: 'kmra8jwrr',
    protocol: '9m1cmv7rc',
    layerName: 'j1jly7yu8',
    auth: 'b63cick5a',
    refreshInterval: 'oc16rulmv',
    categoryMapping: 'df56digkd',
    status: 'otvblgl54',
    lastSynced: '54kyfrbi7',
    featureCount: 's52szjmo7',
    orgId: 'rczcol8vy',
  },
  gisFeatures: {
    sourceId: 'fxnwg66vh',
    featureName: 'psi0t8inf',
    category: 'jwvkahpz5',
    latitude: 'xctxcak9g',
    longitude: 't4k70374l',
    geometry: 'ze1ikgau1',
    properties: 'z4at19cf3',
    incidentId: 'nczc6nszo',
  },
  debrisCrews: {
    contractorId: 'rjz5mz7sv',
    crewName: '60w2tfzy5',
    foremanName: 'c1r1adzpd',
    foremanPhone: 'zwlwxf8ms',
    memberCount: '0ccm18ouq',
    assignedZone: 's71eh560d',
    status: 'sx9xce5pm',
    notes: 'uwvyz0cod',
  },
  debrisPhotos: {
    incidentId: '247r9zqec',
    ticketId: '98e5msl7p',
    zoneId: 'znhrlrz2p',
    photo: 'bfoja7h0p',
    caption: 'oky7pmm63',
    category: 'u1fx8gx3c',
    latitude: '0zp2g40ge',
    longitude: '1xwirgws4',
    takenBy: '1sjoo9x0l',
    takenAt: 'eomlccfng',
  },
  debrisDocuments: {
    incidentId: '6so0biags',
    title: 'u0bynptsh',
    documentType: 'rbintfivi',
    file: '99p465l3p',
    uploadedBy: 'bzfpfc2ee',
    notes: 'a21kk1kh7',
  },
  shelters: {
    incidentId: 'zyuuckmds',
    name: '43g9u3z1e',
    address: 'q0l8b0pxa',
    city: 'xpx98mdne',
    state: 'xmrax5m90',
    zip: '0szv5m2le',
    latitude: '4l4sif3w4',
    longitude: 'rvupjbfaq',
    capacity: 'wsm9cg1rp',
    currentPopulation: '0cclzuaby',
    shelterType: '832akbh7y',
    status: '34w0e1sq6',
    isADA: 'qpfoozeh5',
    isPetFriendly: 'tmvjrgcff',
    amenities: 'gpkfv49os',
    contactName: 'gune8vrji',
    contactPhone: 'p2tlocqox',
    operatingOrg: 'iv7nvkmx0',
    notes: 'idbvdj3dc',
  },
  survivors: {
    shelterId: '8om48xacu',
    incidentId: '98lzozmwy',
    familyId: 'vqbaru1az',
    firstName: 'feftbgsr6',
    lastName: 'w0ck9u6up',
    dateOfBirth: 'cdrks8gc9',
    gender: '7zu6qt6ag',
    phone: 'efwhf0qh9',
    email: 'k2bbzcgkn',
    address: 'dviwh4f7v',
    city: '721k6mamk',
    state: 'yrdydhtjg',
    zip: 'qawby1jfj',
    emergencyContactName: '2yorwpsel',
    emergencyContactPhone: 'mx7bnjnjb',
    medicalNeeds: 'vijwnmtah',
    dietaryNeeds: 'q3iftsend',
    hasPets: '7vfktisl0',
    status: '5uogq7a7i',
    checkInTime: '9y2are3ug',
    checkOutTime: 'akknpzizp',
    registeredBy: 'g8hwye2sy',
    notes: '03pl2mys6',
  },
  shelterFamilies: {
    shelterId: 'urrfd0n4l',
    familyName: '2h5xdflbk',
    headOfHousehold: 'isgk80rcz',
    memberCount: '00hvha7h1',
    unit: 'c5d78wdvh',
    notes: '8p5iriijl',
  },
  shelterPets: {
    survivorId: 'c2po3gkcz',
    shelterId: '2o2yl9oad',
    petName: 'bf6tmswxd',
    species: '6x3xyqdsh',
    breed: 'eidxxjave',
    color: '8lna8xlqs',
    weight: 'r2rckjxqm',
    vaccinated: 'cr8cqdaqh',
    specialNeeds: 'jsd1ydq9r',
    notes: 'aq4e0j8kf',
  },
  shelterMedicalLog: {
    survivorId: 'ed99tgidz',
    shelterId: '7qw5l6gq0',
    incidentType: 'dtf3fp4ac',
    description: 'htxrmt4b3',
    treatment: 'clo13l35v',
    severity: 'lufh369p4',
    treatedBy: 'rh2exz4q3',
    referral: '53emxt8dr',
    timestamp: 'yuzp7i3ax',
    notes: '56or6ptqm',
  },
  shelterTransfers: {
    survivorId: 'gfgk74nz8',
    fromShelterId: 'qq99d9vu3',
    toShelterId: 'j70m9qbgt',
    reason: '8twebhh4a',
    transferDate: '7my9u4moo',
    authorizedBy: 'hork8icu7',
    notes: '7nf0i9mt3',
  },
  shelterReunification: {
    shelterId: 'oxaa1b1xo',
    requestorName: '3yabeywzf',
    requestorPhone: 'e4y1txc25',
    requestorEmail: 'wbermyqrd',
    requestorRelationship: 'i8l18a19l',
    missingPersonName: 'xt5os77gl',
    missingPersonDOB: '9yml7rakm',
    missingPersonPhone: '560v6aaom',
    missingPersonDescription: '2k5cd7ppo',
    matchedSurvivorId: 'xdlmax3kf',
    matchConfidence: 'iutolanwt',
    status: 'ttu369bmg',
    notes: '9wm9qp850',
  },
  shelterFacilityLibrary: {
    name: 'm7evwjamp',
    address: 'atwnv5fq7',
    city: '9ty2v89f7',
    state: 'kuij74l98',
    zip: 'h6oi2maii',
    latitude: 'j4xqck98k',
    longitude: '0k4kizof4',
    capacity: 'gla9dt0ek',
    shelterType: '1r9kh3hp5',
    isADA: 'y651x237p',
    isPetFriendly: 'dsmfiu99m',
    amenities: 'd8nilp18i',
    contactName: 'y4axnzhz4',
    contactPhone: 'gw5aw6es0',
    operatingOrg: 'se1vtktil',
    notes: 'i5mc3zqua',
  },
  shelterVehicles: {
    survivorId: 'lizkqncau',
    shelterId: 'fc8kom4rj',
    make: 'ak448czdo',
    model: 'vz05ih6se',
    year: 'ueb5z9nrt',
    color: 'jv5pt22lh',
    licensePlate: 'evkd18ye4',
    parkingLocation: 'u831bxrot',
    notes: 'rmv9u9wj8',
  },
  shelterIncidents: {
    shelterId: '24r8ccl2m',
    incidentType: '0uddyh2w1',
    description: 'a6ezghhtm',
    severity: 'kgqxhib15',
    reportedBy: 'ckbcdc6dk',
    reportedAt: 'db9lc4bui',
    resolvedAt: 'kwskd7s9a',
    notes: 'e1oz9wvhh',
  },
  shelterReferrals: {
    survivorId: 'wx1y3xg7w',
    shelterId: '0narwzaeh',
    referralType: 'bg4bb83ao',
    agency: 'e44xq5lzu',
    contactInfo: '8k2s0rw6n',
    status: 'gnehbq9lb',
    notes: 'fwr3wwkww',
  },
  shelterSupplies: {
    shelterId: 'chamn3fex',
    itemName: 't87lxnykd',
    category: 'w0p72p1f9',
    quantity: '4aa7spv47',
    unit: 'w7zrr53bq',
    reorderLevel: '1jxcs505v',
    lastRestocked: 'xd59y68oq',
    notes: 'p8w4dkxfp',
  },
  impactAssessments: {
    incidentId: 'l8rswxjqw',
    assessmentType: '00128obqr',
    address: 'bn7ka563w',
    city: 'j6frlexxm',
    state: 'bppcz2cpd',
    county: 'mflggdalw',
    zip: 'bg62pj0of',
    latitude: 'kpeufh4ro',
    longitude: 'i9tqijdjv',
    damageCategory: 'jvla1azu3',
    description: 'wiyvr33xo',
    assessorName: 'qixhg2b3b',
    assessorEmail: 'biwy4kuo1',
    assessmentDate: '2ej72xp3p',
    estimatedLoss: 'dyiqq09y5',
    occupancyType: '1fu7bds48',
    structureType: 'kmx4wh6v1',
    stories: 'n54rnrlgx',
    floodDepth: '3kszm05th',
    status: 'ep8kurpo5',
    notes: 'r912gg78f',
  },
  impactPhotos: {
    assessmentId: 's0uq39ijj',
    photo: 'af373n1oh',
    caption: 'v836z0h6o',
    category: 'ux0tnvzf3',
    latitude: 'vuexv8xy9',
    longitude: 'o25dofd43',
    takenBy: 'etku34bgp',
    takenAt: '2855izoy8',
  },
  impactDetails: {
    assessmentId: 'lebzh9wdo',
    component: '0c72cwrbx',
    damageLevel: 'qiwsss9j8',
    repairCost: 'z2ham1v1q',
    description: 'c1rbf7w8z',
  },
  impactSelfReports: {
    incidentId: 'yx0znhi1r',
    reporterName: 'd9jmdrosl',
    reporterPhone: 'oytjg1dv3',
    reporterEmail: 'un42ddbv4',
    address: '0xtd5alqu',
    city: '3d1l0xwfp',
    state: '51jv8grhl',
    zip: 'lgsi4jj7t',
    latitude: '7coad4bsp',
    longitude: 'bcejn5ic3',
    damageType: 'uey88mhss',
    severity: 'ra7za5uc3',
    description: 'r14quk4rr',
    photoData: 'sra9vdoku',
    status: '4hrp3e69s',
  },
  individuals: {
    incidentId: 'apwuv6fis',
    firstName: '3lqzv51e0',
    lastName: 'ay2kyrmrl',
    dateOfBirth: '7oqdq5ntf',
    gender: '2ebpeabcg',
    phone: 'cscefn16b',
    email: 'dl92hkfd9',
    address: 'anu9tiqt9',
    city: 'j70w9azz1',
    state: 'wh70barrh',
    zip: 'zvl22lcqi',
    triage: 'n0yu4x037',
    status: '8ssyr3o8m',
    emergencyContactName: 'f9nxxiikl',
    emergencyContactPhone: '7f28q8b07',
    medicalNeeds: 'oo0yeazii',
    registeredBy: 'r8r34uc6e',
    registeredAt: '93af6vllh',
    dischargedAt: 'ae4fltj1g',
    notes: '1adh0qqwr',
  },
  propertyItems: {
    individualId: 'vgzm5psbq',
    itemType: '41k1nwy4i',
    description: 'aru4rnqw6',
    serialNumber: 'vo7tpbm6u',
    estimatedValue: '8fzv98ufq',
    photo: 'w2rgue620',
    status: 'ef7augrty',
    notes: 'jo2uc623c',
  },
  laborEmployees: {
    employeeName: '4jnychdf1',
    employeeId: 'k9fzho9uh',
    jobTitle: '5vbnmpudj',
    department: 'odr9ht3zl',
    employmentType: 'gmwlr36f0',
    flsaStatus: 'bwfdrnuru',
    budgetStatus: 'ac2atnz0v',
    regularRate: '0owcsbd57',
    overtimeRate: '2n5bzx941',
    totalFringePct: 'iw9vycst2',
    totalHourlyRate: 'wyhu1ajbv',
    rosterEmail: 'dmnh6tyrl',
    organizationId: 'ga3udtua7',
    normalWeeklyHours: 'kue4nif3b',
    hireDate: 'r1ryuhgnm',
    defaultAccountCode: 'v5uzwqp8j',
    defaultProgramCode: 't5ubw6ig1',
    status: '5ngn9qel5',
    notes: '5bhjboakn',
  },
  forceAccountLabor: {
    incidentId: 'n67rbwddv',
    projectId: 'xw4reszl5',
    organizationId: 's782kr8wx',
    employeeName: 'vydsx6ial',
    employeeId: 's8lc0ik2w',
    employeeTitle: 'ghz8k5k7x',
    workDate: 'ilknq3njr',
    hoursRegular: '6ynvi4p44',
    hoursOvertime: '67dt75u3f',
    rateRegular: 'd3rp0kuei',
    rateOvertime: 'y7ib1cw7f',
    laborCost: 'td4pvjmyt',
    fringeCost: '7eddus6vr',
    totalCost: 'x8kgrwonp',
    fringeBenefitsPct: '33udouida',
    activityDescription: '3odkvx3i3',
    category: 'pfrf3tyx4',
    status: 'hesw82g54',
    approvedRegHours: 'ci38xy2g9',
    approvedOTHours: 'gq71u9alw',
    approvedCost: 'msiog8o6h',
    reviewerNotes: 'utk5io984',
    accountCode: 'qkzlqxx5j',
    programCode: 'rkvfag6g5',
    shiftPremium: 'p2ae64695',
    notes: 'zdj9ii603',
  },
  geoOpsZones: {
    incidentId: '8320w76cm',
    name: 'u5foxf45u',
    zoneType: '31cloh7oa',
    geometry: 'adkfr9srs',
    status: 'ybzcbrc24',
    color: 's4jnuaups',
    opacity: '9nljni35l',
    notes: 'b0f37au2d',
    createdBy: 'udl03xhpz',
    sortOrder: 'qj54ugzca',
    metadata: '9whhgoc7j',
  },
  observations: {
    incidentId: '4y8lf9iss',
    title: 'lg2ukwn5l',
    tier: 'clp155slc',
    category: 'mvga3pu5i',
    description: 'i2awbwu1p',
    recommendation: '4cbve4yui',
    assignedTo: 'r4qajyrc5',
    status: '74nrkcvsv',
    submittedBy: 'yokovgapv',
    submittedByEmail: 'auidwj54i',
  },
  aiInsights: {
    incidentId: 'cx0ncr9li',
    insightType: '0182liwd3',
    content: 'xk10rtw0v',
    model: 'idwwdssr6',
  },
  handoffEvents: {
    incidentId: 'y7x0bo12d',
    eventName: '23kytx6aj',
    status: '07676t7u6',
    createdByName: '7kq2z5pmt',
    createdByEmail: 'ekxjb1o1g',
  },
  handoffPositions: {
    eventId: 'w3amibyp4',
    positionName: '8u9i7mufr',
    dayShiftName: '8lgv00ph8',
    dayShiftEmail: 'jh9vud073',
    nightShiftName: 'i24rs7d1x',
    nightShiftEmail: 'bwrr90npa',
    sortOrder: 'i03ifaz3b',
  },
  handoffNotes: {
    eventId: 'litd0o8rc',
    positionName: 't27grl1bl',
    fromShift: 'cso0fjbqg',
    toShift: 'roz6zkoey',
    senderName: 'c2b8sdzj6',
    senderEmail: 'lbo0d1wfu',
    recipientName: '8oztjkd19',
    recipientEmail: 'h9ly2ido9',
    sectionsJson: 'xjbsdweop',
    signature: '7o2q58tcy',
    status: 'ldmksz226',
    acknowledgedAt: 'sbw9tibcf',
  },
  handoffActionItems: {
    eventId: 'mv0s3amo3',
    noteId: 'c6j7o6w3g',
    title: 'a1u9anj2s',
    description: 'bv0dfhepj',
    assignedTo: 'ao7efjlmu',
    assignedToEmail: '1zxk10uc1',
    priority: 'j8n9lqwm9',
    status: 'q66zusv24',
    dueDate: 'lhfzy53wn',
    completedAt: 'diu6lu8f1',
    notes: 'zzyadx6z7',
  },
  rcPersonnel: {
    fullName: 'e3rc39icj',
    agency: 'l6smowxze',
    position: 'wl6o8ehpf',
    phone: 'dy3otgfxj',
    email: 'u1f2yafca',
    badgeId: '3o4x91gsn',
    pin: 'kp1i6whvn',
    status: 'lb52jkdn5',
  },
  rcEvents: {
    incidentId: 'yufgy6cqn',
    eventName: 'sg879uboo',
    eventType: '5i9fzwwka',
    eventStatus: 'isbsgc6mn',
    location: 'r54ysgrl6',
    startTime: 'b4a4ltm20',
    endTime: 'g4bh0a2jo',
    checkInCode: 'wlc48qik3',
    notes: '5fotene8f',
  },
  rcCheckins: {
    eventId: 'rr50elsum',
    personnelId: '740xpk14d',
    personName: 'd7jaoerxd',
    agency: '1lxv8nfe7',
    checkInTime: '41w346o56',
    checkOutTime: 'rr9heao79',
    method: 'ncuwljtcq',
    notes: '1cvbw8x37',
  },
  brMeta: {
    incidentId: 'hv80n8k7q',
    name: 'cm2dvq9xw',
    status: 'pzwbseuha',
    notes: 'yhcl7pkeh',
  },
  brEvents: {
    metaId: 'chn3qd72c',
    title: 'd73j1dxmq',
    eventType: '717kncnh6',
    startTime: '3zhr4l81q',
    endTime: 'ortxe5gvn',
    recurrence: '0pb2o46b7',
    location: 'p74et10gv',
    participants: 'cprfsnivi',
    status: '5w4id0zec',
    notes: 'qn1putjq0',
  },
  brTemplates: {
    name: '7nq1babzj',
    description: '2r735e2q6',
    eventsJson: 'uq2svt268',
  },
  paceProfiles: {
    incidentId: 'pgi58ovek',
    profileName: 'b8e2s7ip8',
    primary: 'poqzlhqhm',
    alternate: 'lx1q00wa4',
    contingency: 'co570u15p',
    emergency: '2fz40u3mg',
    status: 'v8tnh0pov',
    notes: 'h7cbk4kms',
  },
  pacePlans: {
    profileId: 'piwijo27a',
    planName: 'kwmoejmdf',
    description: '09q3we7qx',
    entriesJson: 'pa0ff1eny',
  },
  pacePlanEntries: {
    planId: '7a85d76mq',
    contactName: 'n922welv1',
    contactTitle: 'g084sinq0',
    phone: 'wp0sr4u38',
    email: 'cil56iuiz',
    radioFreq: 'is5q50co2',
    method: 'zzmga68zp',
    sortOrder: 'i01irw9kl',
  },
  callDowns: {
    profileId: 'fkudgci9p',
    title: '9b4pd2853',
    message: '0kxzuvawp',
    templateId: 'd09svjupl',
    status: '9xn8fc5al',
    initiatedBy: '0k024by62',
    initiatedAt: 'djo7pjcnu',
    totalContacts: 'hzgn4x8q1',
    confirmedCount: 'tr2otbszk',
  },
  callDownResponses: {
    callDownId: 'jn20sgxu4',
    contactName: 'klypa31pw',
    contactPhone: 'sjxtpqd20',
    contactEmail: 'unpw7yb54',
    status: 't46r4fqfr',
    respondedAt: '2jrljch6f',
    notes: 'c5i3dcm6f',
  },
  callDownTemplates: {
    name: 'c9y6o2mna',
    message: 'hqfaxuaxt',
    contactListJson: '0u6r1oei3',
  },
  volunteers: {
    firstName: 'twruc91x0',
    lastName: 'ltcpklpyl',
    email: '3rte4ofhi',
    phone: 'ngg00dt2j',
    address: '6t9ynw223',
    city: 'zhxyq0l1g',
    state: 'ixq5n21iw',
    zip: 'h5hk6r3zc',
    skills: '5r6p27155',
    certifications: 'i6wdx9og6',
    availability: 'uhwrffjx7',
    emergencyContact: 'n8ib7kjsw',
    emergencyPhone: 't2bxd11xa',
    status: 'acvl8xt05',
    notes: 'jbxd1v6p9',
  },
  volunteerEvents: {
    incidentId: 'tm9kit5vs',
    eventName: 's9h669cbl',
    eventDate: '1bdhj6jhs',
    startTime: 'skwcu5j0f',
    endTime: 'pubufacs0',
    location: 'dm5a3iyc2',
    description: '4dnvt8drt',
    requiredSkills: 'k3xz0b505',
    maxVolunteers: 'x9jm24rpi',
    checkInCode: 'jae1dgm4y',
    status: 'uveuqj8m7',
    notes: 'kdsoti83j',
  },
  volunteerAssignments: {
    eventId: '7ptyuun26',
    volunteerId: '3e0aniw10',
    volunteerName: 'y3srnwdit',
    role: '8jztziw0y',
    status: '7i5blv3ic',
    checkInTime: 'figciqo5t',
    checkOutTime: 'f0md91di4',
    hoursWorked: 'mvcjputxw',
    notes: 'oi0r17i4p',
  },
  bbTrainings: {
    name: 'quuc1kpbn',
    category: '8zvhtyp3g',
    provider: 'wdbw6m0nn',
    description: 'foqrqy3x9',
    requiredForPositions: '9ptct2nvn',
    recertMonths: '87x4yax88',
    status: '2apuzd49s',
  },
  bbTrainingRecords: {
    trainingId: 'wst9kvwo7',
    userId: '2kzadsthl',
    userName: 'zc710x35v',
    userEmail: '3my1run4s',
    completedDate: '4lrpjmy4q',
    expiresDate: 'bxtpmjz75',
    score: '5dql81l7v',
    status: 'wb72kbps3',
    certCode: 'yygrjrhvp',
    notes: '15d8ik7bq',
  },
  bbClassrooms: {
    trainingId: 'sly8wq94b',
    className: 'xg8p3xpd7',
    instructorName: 'r0b2rwerh',
    instructorId: '9ntqhy8ph',
    classDate: 'zzjf1gelm',
    startTime: 'nyd7bgz6e',
    endTime: 'yq0r88hw8',
    location: 'warp1tdim',
    capacity: 't9t5w4w01',
    enrolled: 'mu5v69my7',
    waitlistCount: '4za410s3e',
    status: 'pmz3cwpxy',
    notes: '5g7thouoq',
  },
  bbCertificates: {
    userId: '94hff13b4',
    userName: '4eyth9bvd',
    userEmail: 'nimrcmmm2',
    trainingId: 'rc34sq4zs',
    trainingName: '3gl726o33',
    completedDate: 'ahbvxb8of',
    expiresDate: '512balm76',
    certCode: '31yqgp7bz',
    status: 'uhsvr4u6g',
  },
  bbPositionPlans: {
    positionName: 'cwi05s0rj',
    description: 'ggqtlmgmh',
    requiredTrainings: 'ucopwo94m',
    sortOrder: '8dwdac6rt',
  },
  bbMessages: {
    recipientEmail: 'hjrd81pdq',
    senderName: '419yv4p19',
    senderEmail: 'zao5i1h7f',
    subject: 't0vbvdo9k',
    body: 'tdyr93ldd',
    channel: '9xat7d9bp',
    targetMode: 'ybbur3eug',
    batchId: 'qwdj76hcl',
    readAt: 'o5zwjkfm4',
    sentAt: 'lx4dzmzf3',
  },
  msOrganizations: {
    incidentId: 'y7kjiu8rs',
    orgName: '707e2hgd2',
    opStatus: 'dyszptezu',
    sector: 'wbqglem1c',
    address: 'b5pa6corg',
    city: 's80hsv77w',
    state: 'bdu7nmkdw',
    zip: 'mjuby24hk',
    latitude: '3n1sxb4cl',
    longitude: 'fe6uxk9ep',
    contactName: 'z4jiar2wg',
    contactPhone: '51raw61qs',
    contactEmail: 'jq8eqrf1r',
    ownerEmail: 'llywfc4xl',
    employeeCount: 'c8ya7kbfx',
    notes: 'b98f1e5md',
  },
  msContacts: {
    orgId: 's47577pjc',
    firstName: 'xua8mfel8',
    lastName: '3fj2w6qm7',
    title: 'dov9j1v99',
    phone: '906ospnyf',
    email: '8v9qyrad0',
    role: 'bebtwo45n',
    notes: 'ik8h4li7q',
  },
  msFacilities: {
    orgId: 'ojxps6ol5',
    facilityName: 'lvy7g5mt0',
    address: 'yd1kanrn6',
    city: 'cec7u6mta',
    state: '9122x9ykw',
    latitude: '4u209r3di',
    longitude: '5fv5myep7',
    facilityType: 'fctz7urwq',
    status: '68l49ach4',
    notes: '20ozh94dr',
  },
  msDamageReports: {
    orgId: 'shs4fcx63',
    reportDate: '2zlisg61e',
    damageType: 'bq8dech1b',
    severity: 'l6wzqwspg',
    description: 'yn70ukzac',
    estimatedLoss: 'f37yr0jok',
    insuranceFiled: 'aprr3pcdk',
    status: 'e9w6xfcof',
    notes: 'qy56lo29s',
  },
  msResourceOffers: {
    orgId: 'edooocwso',
    resourceType: '1vmt37dx2',
    description: '12ukzv3kc',
    quantity: '9in7fquhj',
    availableFrom: 'h8pu42eg3',
    availableTo: 't3h3alfan',
    contactName: 'tqljzms2b',
    contactPhone: '8i7pctzl0',
    status: 'ibudxjbd0',
  },
  msStatusChecks: {
    incidentId: '6ejxdmxuy',
    title: 'w0jr1g6ox',
    message: '4q2slxszx',
    sentAt: 'jtbm63835',
    totalSent: 'a04asla8f',
    responseCount: 'olk6aq4je',
  },
  msStatusResponses: {
    checkId: '45rx5x0cn',
    orgId: 'rb401zert',
    orgName: 'qsknxi00p',
    opStatus: 'kc5k92fwj',
    respondedAt: 'wi86u3suh',
    notes: '3e2w77ch4',
  },
  msReentryAuthorizations: {
    incidentId: 'ys4bkpeym',
    title: '1n0fspmwe',
    zones: '4ufciaces',
    validFrom: '6xjcgdiw6',
    validTo: 'szkg3zpnx',
    issuedBy: 'zm1oqfkn1',
    status: 'l960ypepv',
    notes: 't8kxa9typ',
  },
  msReentryPasses: {
    authId: 'ln1lx7c5e',
    orgId: '52lzxbhwj',
    orgName: 'f03o72don',
    passCode: 'mlpvwqikk',
    status: 'nbifluufw',
    issuedAt: 'niw7xakry',
    expiresAt: 'olkjx83uo',
    verifiedAt: 'ao85nkjyj',
    verifiedBy: '5lm93pymt',
  },
  msOrgLists: {
    listName: 'cc7vapag1',
    description: 'zbbth5m7j',
    orgIds: 'ojbm0g1ad',
    createdBy: 'kv7wqtocn',
  },
  flDocuments: {
    title: 'n9g756u28',
    description: '3gobd6bv5',
    categoryId: 'fmc6h2eio',
    tags: '1u0rmqc7n',
    file: 'mjuayke0c',
    uploadedBy: 'eqi5v3dl5',
    publishedAt: 't28oy664g',
    status: 'k30mu1sj4',
  },
  flCategories: {
    name: 's1h8o6bcd',
    description: '78n4dx3as',
    color: 'jovxz9rpm',
    sortOrder: 'jhnjdguj3',
  },
  workflowTemplates: {
    name: 'z1v3zgi3w',
    description: 't28l0ges4',
    triggerType: 'gnublbv1a',
    triggerTable: 'tcp5258ax',
    triggerField: 'c1furstta',
    triggerValue: 'l79bhgmf3',
    stepsJson: 'f4e1elg82',
    isActive: 'kvqy62bx6',
    createdBy: 'i0hsp20b9',
  },
  workflowInstances: {
    templateId: 'l2qh7v05b',
    templateName: '7unkiddv5',
    status: 'fkuearz8d',
    currentStep: 'v9pzw5voa',
    contextJson: '1kvewn4te',
    startedBy: 'rh8hnv2ud',
    startedAt: 'rbkbhag3i',
    completedAt: 'xv7oqq2ps',
    sourceModule: 'nmowprom3',
    sourceRecordId: 'sesy60uzh',
  },
  workflowSteps: {
    instanceId: 'x0p3bju1t',
    stepIndex: 'zz6s4sxj5',
    stepName: 'oj9zt1mpj',
    stepType: 'x3y4mz4mv',
    assignedRole: 'ufuwpr8pz',
    assignedUser: 'wo5pmx7dq',
    status: '4kuuca7x4',
    completedBy: 't30qoza81',
    completedAt: 'mxc2f0tqm',
    notes: 'zng14wymq',
  },
  formTemplates: {
    title: 'itywo2rwy',
    description: 'q8fdqtl1s',
    schemaJson: 'dv8p12ign',
    settingsJson: 'qi4y3jmqj',
    status: '9ahf71pkw',
    createdBy: '2yqbkilha',
    responseCount: 'x90pielsz',
  },
  formResponses: {
    templateId: '7anebi8by',
    respondentName: 'ygzfgrbaz',
    respondentEmail: 'nxrnawcul',
    answersJson: 'f9v4z5ff2',
    status: '4zihw37fy',
    submittedAt: '0pr4locgc',
  },
} as const;
